// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isAllCardsResult = objectOf({
  cards: arrayOf(
    objectOf({
      id: string,
      value: maybe(string, true),
    })
  ),
});
